import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Button from "../../shared/button/Btn"
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { showNestedModal } from '../../../features/modal/modalSlice'
import { useScrollLock } from '../../../hooks/useScrollLock'
import { useLocation } from 'react-router-dom'
import { handleActiveSelect } from '../../../features/layout/layoutSlice'
import PageTopTitle from '../../shared/PageTopTitle'
import { firmalarimDelete, setFirmaRoutePoints, setFirmaSelectRouteForMap, setIsDetailOpen, setSelectMapLatLng, setUpdatedFirmalarimData } from '../../../features/firma/FirmaSlice'
import FirmaUpdate from './FirmaUpdate'
import { GoogleMap, Marker } from '@react-google-maps/api'
import Btn from '../../shared/button/Btn'

const ModalContainer = styled.div`
     position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;
    .modal{
        width: auto;
        max-height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
        overflow: auto;
        .container{
            width: 100%;
            padding: 30px;
            position: relative;
        }
        .btn{
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 15px;
            padding-bottom: 30px;
        }
    }

`

 

const FirmalarimMap = () => {
  const dispatch = useDispatch()
  const {modalLocation } = useSelector(state => state.modal)
  const {firmaSelectRouteForMap, selectMapLatLng} = useSelector(state => state.firma)
  const { lockScroll, unlockScroll } = useScrollLock();
  const location = useLocation()

  const [defaultCenter, setDefaultCenter] = useState( selectMapLatLng ? selectMapLatLng : {
    lat: 39.55, 
    lng: 34.50  
  })

  const containerStyle = {
    width: '800px',
    height: '600px'
  };

  //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showNestedModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const onMapClick = async (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        setDefaultCenter({lat: lat, lng:lng})
        await reverseGeocode(lat, lng);
    };

    async function reverseGeocode(lat, lng) {
        const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`;
      
        try {
          const response = await fetch(apiUrl);
          const data = await response.json();
          if (data.status === "OK") {
            
            dispatch(setFirmaRoutePoints({id:firmaSelectRouteForMap.id, routeLocation:data.results[0].formatted_address, lat:lat, lng:lng }) );
            dispatch(setFirmaSelectRouteForMap({...firmaSelectRouteForMap, routeLocation:data.results[0].formatted_address, lat:lat, lng:lng}))
            return data.results[0].formatted_address; 

          } else {
            throw new Error(data.error_message || "Geocoding başarısız.");
          }

        } catch (error) {
          console.error("Geocoding hata:", error);
          return null;
        }
    }

  return (
    <ModalContainer onClick={()=> {dispatch(showNestedModal(null));}}>
        <div className="modal" onClick={(e) => { e.stopPropagation(); dispatch(handleActiveSelect(null)) }}>
            <PageTopTitle isDiffPage title={"Firma"}/>
            <div className="container">
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={defaultCenter}
                    zoom={6}
                    onClick={onMapClick}
                >
                    {firmaSelectRouteForMap  && <Marker position={{lat:firmaSelectRouteForMap.lat, lng:firmaSelectRouteForMap.lng}} /> } 
                </GoogleMap>
            </div>

            <div className="btn">
                <Btn handleClick={()=> {dispatch(showNestedModal(null));}} width={"150px"} color='#E85446' bgColor='#fff' >Kaydet</Btn>
                <Btn handleClick={() =>{ dispatch(setFirmaRoutePoints({id:firmaSelectRouteForMap?.id, routeLocation:"" })); dispatch(showNestedModal(null))}} width={"150px"} bgColor='#E85446' color='#fff' >Kapat</Btn>
            </div>
        </div>
    </ModalContainer>
  )
}

export default FirmalarimMap